import { render, staticRenderFns } from "./TransferPaymentInfo.vue?vue&type=template&id=7799a1f0&scoped=true"
import script from "./TransferPaymentInfo.vue?vue&type=script&lang=ts"
export * from "./TransferPaymentInfo.vue?vue&type=script&lang=ts"
import style0 from "./TransferPaymentInfo.vue?vue&type=style&index=0&id=7799a1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7799a1f0",
  null
  
)

export default component.exports